export const blockIconsFileFolder = (
	<span className='material-symbols-outlined'>folder</span>
);
